import getEnvFromHostname from './getEnvFromHostname';

type BuildServiceUrlProps = {
  subdomain?: string;
  baseEnv: string;
  targetPort?: string | null;
  path?: string;
};

const buildServiceUrl = ({
  subdomain,
  baseEnv,
  targetPort,
  path,
}: BuildServiceUrlProps): string => {
  const isLocal = getEnvFromHostname() === 'local';
  const subdomainPrefix = subdomain ? `${subdomain}.` : '';
  const port = targetPort && isLocal ? `:${targetPort}` : '';

  return `https://${subdomainPrefix}${baseEnv}${port}${path}`;
};

export default buildServiceUrl;
